import { Field, Label, Switch } from '@headlessui/react';
import { cn } from '../../../utilities/cn';

export interface RSwitchProps {
  enabled: boolean;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  trackClassName?: string;
  label?: string;
  labelOn?: string;
}

export default function RSwitch({
  enabled,
  setEnabled,
  className,
  trackClassName,
  label,
  labelOn,
}: RSwitchProps) {
  return (
    <Field>
      <div className="my-2 flex items-center gap-4 rounded-lg bg-white">
        {label && (
          <Label className="text font-medium text-gray-900">{label}</Label>
        )}
        <Switch
          checked={enabled}
          onChange={setEnabled}
          className={cn(
            `group relative flex h-7 w-14 cursor-pointer rounded-full bg-mainblue p-1 transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-mainblue data-[focus]:outline-1 data-[focus]:outline-white`,
            className,
          )}
        >
          <span
            aria-hidden="true"
            className={cn(
              'pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-7',
              trackClassName,
            )}
          />
        </Switch>
        {labelOn && (
          <Label className="text font-medium text-gray-900">{labelOn}</Label>
        )}
      </div>
    </Field>
  );
}
